export default __webpack_public_path__ + "static/media/6.ef5ce678.jpg";